export default "__VITE_ASSET__b2843a06__"